<template>
  <div class="table-box-items table-customer-style">
    <div class="project-title">{{ projectTitle }}</div>
    <el-table
      ref="tableRef"
      size="medium"
      :border="true"
      @sort-change="sortChange"
      v-loading="loading"
      :data="tableData"
      row-key="id"
      max-height="320"
      style="width: 100%"
    >
      <el-table-column
        v-for="(item, i) in filterColumnData"
        :key="i"
        :show-overflow-tooltip="!item.isBold ? true : false"
        :align="item.align"
        :prop="item.key"
        :label="item.label"
        :min-width="item.width ? item.width : 'auto'"
        :sortable="item.sortable ? 'custom' : false"
        :class-name="item.className || ''"
      >
        <template v-if="item.children && item.isShow">
          <el-table-column
            v-for="(item, i) in item.children"
            :key="i"
            :show-overflow-tooltip="!item.isBold ? true : false"
            :align="item.align"
            :prop="item.key"
            :label="item.label"
            :min-width="item.width ? item.width : 'auto'"
            :sortable="item.sortable ? 'custom' : false"
            :class-name="item.className || ''"
          >
          </el-table-column>
        </template>
      </el-table-column>

      <!-- <el-table-column
        :align="'left'"
        prop="settleName"
        label="结算项目名称"
        width="200">
      </el-table-column>
      <el-table-column
        :align="'left'"
        prop="settleDept"
        label="所属部门"
        width="160">
      </el-table-column>
      <el-table-column
        :align="'left'"
        prop="investigatorsNum"
        label="关联项目数"
        sortable
        width="170">
      </el-table-column>
      <el-table-column
        :align="'right'"
        width="170"
        sortable
        prop="expectedYuanAmount"
        label="到手金额(元)">
      </el-table-column>
      <el-table-column
        :align="'right'"
        width="170"
        sortable
        prop="serviceYuanAmount"
        label="服务费(元)">
      </el-table-column> -->
      <el-table-column
        v-if="lastColumn.isShow"
        :align="'right'"
        sortable="custom"
        :key="lastColumn.key"
        :prop="lastColumn.key"
        :label="lastColumn.label"
        min-width="139px"
      >
        <!-- <template slot-scope="{ row }">
          <div style="display: flex">
            <div :style="{ width: 80 * (parseFloat(row.percentage) / 100) + 'px', paddingTop: '3px', marginRight: '5px' }">
              <el-progress
                :color="row.processColor || processColor"
                :text-inside="true"
                :stroke-width="14"
                :percentage="100"
              ></el-progress>
            </div>
            <span style="font-weight: bold">{{ row.operationalYuanAmount }}</span>
          </div>
        </template> -->
      </el-table-column>
      <el-table-column v-if="lastColumn.isShow" :align="'center'" label="操作" min-width="63px">
        <template slot-scope="scope">
          <el-button @click="checkDetails(scope.row)" type="text" size="small"> 查看 </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'TableList',
  props: {
    tableKey: {
      type: String,
      default: ''
    },
    columnData: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    },
    lastColumn: {
      type: Object,
      default: () => ({})
    },
    searchDate: {
      type: Array,
      default: () => []
    },
    projectTitle: {
      type: String,
      default: ''
    },
    processColor: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // tableData:[
      //   {
      //     settleName:'测试测试测试测试测试测试测试测试测试测试测试测试测试项目A',
      //     settleDept:'部门A',
      //     investigatorsNum:300,
      //     expectedYuanAmount:1000,
      //     serviceYuanAmount:100,
      //     operationalYuanAmount:3000,
      //     percentage:'100.25%'
      //   },
      //   {
      //     settleName:'项目B',
      //     settleDept:'部门B',
      //     investigatorsNum:300,
      //     expectedYuanAmount:1000,
      //     serviceYuanAmount:100,
      //     operationalYuanAmount:1000,
      //     percentage:'30.25%'
      //   },
      //   {
      //     settleName:'项目C',
      //     settleDept:'部门C',
      //     investigatorsNum:300,
      //     expectedYuanAmount:1000,
      //     serviceYuanAmount:100,
      //     operationalYuanAmount:2000,
      //     percentage:'80.25%'
      //   },
      //   {
      //     settleName:'项目D',
      //     settleDept:'部门D',
      //     investigatorsNum:300,
      //     expectedYuanAmount:1000,
      //     serviceYuanAmount:100,
      //     operationalYuanAmount:2000,
      //     percentage:'80.25%'
      //   },
      // ],
      // columnData:[
      //   {key:'settleName',label:'结算项目名称',align:'left',width:200},
      //   {key:'settleDept',label:'所属部门',align:'left',width:160},
      //   {key:'investigatorsNum',label:'结算调查员人数',align:'right',width:175,sortable:true,isBold:true},
      //   {key:'expectedYuanAmount',label:'到手金额(元)',align:'right',width:170,sortable:true,isBold:true},
      //   {key:'serviceYuanAmount',label:'服务费(元)',align:'right',width:150,sortable:true,isBold:true},
      //   // {key:'operationalYuanAmount',label:'结算总费用(元)',align:'left',sortable:true,customerRender:true},
      // ],
      // lastColumn:{key:'operationalYuanAmount',label:'结算总费用(元)'},
      // projectTitle:'按项目',
      // processColor:'#2775E8',
    }
  },
  computed: {
    filterColumnData() {
      return this.columnData.filter(it => it.isShow)
    }
  },
  methods: {
    checkDetails(row) {
      // const statementIds = Array.from(new Set(row?.statementIds || [])).join(',')
      const queryParams = this.getQueryParams(row)
      // this.$router.push({ name: 'project-detail', query: { statementIds, ...queryParams } })
      this.$router.push({ name: 'project-detail', query: { ...queryParams } })
    },
    sortChange({ column, prop, order }) {
      this.$emit('emitSortChange', prop, order, this.projectTitle)
    },
    getQueryParams(item) {
      const {
        settleName: stn,
        settleDept: std,
        settleObjType,
        creatorName: cm,
        investigatorName: invName,
        investigatorPhone: invPhone,
        projectCategory
      } = item || {}
      const parmas = { searchDate: encodeURIComponent((this.searchDate || []).join(',')) }
      switch (this.tableKey) {
        case 'bySettleName':
          const settleName = encodeURIComponent(stn)
          return { ...parmas, settleName }
        case 'bySettleDept':
          const settleDept = encodeURIComponent(std)
          return { ...parmas, settleDept }
        case 'bySettleObjType':
          const invNameStr = (invName || '').split(/-/g)[0] || ''
          const investigatorName = encodeURIComponent(invNameStr)
          const investigatorPhone = encodeURIComponent(invPhone)
          return { ...parmas, settleObjType, investigatorName, investigatorPhone }
        case 'byCreatorName':
          const creatorName = encodeURIComponent(cm)
          return { ...parmas, creatorName }
        case 'byProjectCategory':
          return { ...parmas, projectCategory }
        default:
          return {}
      }
    }
  },
  watch: {
    columnData: {
      handler(val) {
        this.$refs.tableRef.doLayout()
      },
      deep: true
    }
  },
  mounted() {}
}
</script>

<style lang="scss">
.table-box-items.table-customer-style {
  .el-table th.el-table__cell > .cell {
    padding-left: 16px;
    padding-right: 16px;
    font-weight: 400;
    font-size: 14px;
  }
  .el-table .cell {
    padding-left: 16px;
    padding-right: 16px;
    font-weight: bold;
    font-size: 14px;
    &.el-tooltip {
      font-weight: normal;
    }
  }
  .el-table {
    .el-progress-bar__outer {
      border-radius: 0;
      background-color: transparent;
    }
    .el-progress-bar__innerText {
      display: none;
    }
    .el-progress-bar__inner {
      border-radius: 0;
    }
  }
  .el-table .caret-wrapper {
    width: 12px;
  }
  .el-table .sort-caret {
    left: 1px;
  }
}
</style>
>
